import Model, { attr, hasMany } from '@ember-data/model';

import type { AsyncHasMany } from '@ember-data/model';
import type {
  UserCapability,
  UserRoleName,
  UserStatus,
} from 'admin-panel/constants/users';
import type SentinelRoleModel from 'admin-panel/models/sentinel/role';

export default class SentinelUserModel extends Model {
  @hasMany('sentinel/role', { async: true, inverse: null })
  declare roles: AsyncHasMany<SentinelRoleModel>;

  @attr
  declare roleNames: UserRoleName[];

  @attr
  declare capabilities: UserCapability[];

  @attr
  declare createdAt: string;

  @attr
  declare deactivatedAt: string | null;

  @attr
  declare email: string;

  @attr
  declare hotelIds: string[];

  @attr
  declare lastSignInAt: string | null;

  @attr
  declare name: string;

  @attr
  declare occupation: string | null;

  @attr
  declare resetPasswordPending: boolean;

  @attr
  declare status: UserStatus;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'sentinel/user': SentinelUserModel;
  }
}
